import type { FC, ReactNode } from 'react'
import type { GetUsers_getUsers } from '@g4g/graphql/src/shop/__generated__/GetUsers'
import { RewardType } from '@g4g/graphql/src/shop/__generated__/globalTypes'
import {
  nextSalePointsDing,
  nextVipExpDing,
  salePointsPctg,
  vipExpPctg,
} from '@g4g/utils/src/gameDataUtils'
import { useRecipient } from '../RecipientProvider'
import { useRecipientSelect } from './RecipientSelectProvider'
import RecipientOnboarding from './RecipientOnboarding'
import RewardProgressBar from '../../shared/top-bar/receipient-section/RewardProgressBar'
import CopyToClipboard from '@g4g/ui/src/components/CopyToClipboard'
import usePickedRecipient from '../hooks/usePickedRecipient'

const RecipientProgress: FC<{
  type: RewardType.SalePoints | RewardType.VipExp
  recipient: GetUsers_getUsers
}> = ({
  type,
  recipient: {
    userState: { vipXP, salePoints },
  },
}) => (
  <>
    <div className="my-4 text-sm text-white/50">
      {type === RewardType.SalePoints ? 'Sale points' : 'VIP experience'}
    </div>
    <div className="flex w-full px-8">
      <RewardProgressBar
        type={type}
        progress={{
          isOverNextDing: false,
          cartPctg: 0,
          nextDing:
            type === RewardType.VipExp ? nextVipExpDing(vipXP) : nextSalePointsDing(salePoints),
          gamePctg: type === RewardType.VipExp ? vipExpPctg(vipXP) : salePointsPctg(salePoints),
          amount: type === RewardType.VipExp ? vipXP : salePoints,
        }}
      />
    </div>
  </>
)

const RecipientAttr: FC<{ label: string; children: ReactNode }> = ({ children, label }) => (
  <div className="flex flex-col w-full mb-2">
    <div className="text-sm text-white/50">{label}</div>
    <div className="text-lg text-white">{children}</div>
  </div>
)

const RecipientInfo: FC<{ cosId: string }> = ({ cosId }) => {
  const { recipient } = usePickedRecipient(cosId)

  return (
    <>
      {recipient && (
        <div className="flex flex-col px-4 mt-2">
          {recipient.primaryLogin && (
            <RecipientAttr label="Username">
              <CopyToClipboard text={recipient.primaryLogin.displayName}>
                {recipient.primaryLogin.displayName}
              </CopyToClipboard>
            </RecipientAttr>
          )}
          <RecipientAttr label="Account ID">
            <CopyToClipboard text={cosId}>{cosId}</CopyToClipboard>
          </RecipientAttr>
          <div>
            <RecipientProgress type={RewardType.VipExp} recipient={recipient} />
            <RecipientProgress type={RewardType.SalePoints} recipient={recipient} />
          </div>
        </div>
      )}
    </>
  )
}

const RecipientSelected: FC = () => {
  const { selectedRadioCosId } = useRecipientSelect()

  return <>{selectedRadioCosId && <RecipientInfo cosId={selectedRadioCosId} />}</>
}

const RecipientDetail: FC = () => {
  const { recentRecipients } = useRecipient()

  if (recentRecipients.length === 0) {
    return <RecipientOnboarding />
  }

  return <RecipientSelected />
}

export default RecipientDetail
